import React from 'react';
import { FAQ, FAQItem } from '../../../../components/faq/faq';

export function BlogFAQs({ faqs, heading }: { faqs: FAQItem[]; heading: string }) {
    return <FAQ FAQData={faqs} heading={heading} />;
}
